import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './home.routes';
import moment from 'angular-moment';

import DeviceStatusService from '../../components/api/device_status/device_status.service';
import EventService from '../../components/api/event/event.service';
import CsvUtil from '../../components/logic/csv_util/csv.util';

export class HomeController {
  /*@ngInject*/
  constructor($filter, $interval, $mdDialog, moment, DeviceStatusService, EventService, CsvUtil) {
    this.announces = [];

    this.$filter = $filter;
    this.$interval = $interval;
    this.$mdDialog = $mdDialog;
    this.moment = moment;
    this.DeviceStatusService = DeviceStatusService;
    this.EventService = EventService;
    this.CsvUtil = CsvUtil;
    this.downloadFileName = 'event.csv';

    this.errorList = [];
    this.correctList = [];
    this.demandAlertList = [];
  }

  $onInit() {
    this.updateStatus();

    this.timer = this.$interval(() => {
      this.updateStatus();
    }, 20000);
  }

  updateStatus() {
    this.EventService.api.index(response => {
      this.events = response;
      this.eventCsv = this.CsvUtil.processEvent(this.events);

      this.downloadFileName = this.moment().format('[event]_YYYY-MM-DD[.csv]');
    });

    this.DeviceStatusService.api.index(response => {
      this.correctList = this.$filter("filter")(response, {has_error: false});

      this.errorList = this.$filter("filter")(response, device_error => {
        return this.isError(device_error);
      });

      this.demandAlertList = this.$filter("filter")(response, device_error => {
        return this.isDemandAlert(device_error);
      });
    });
  }

  $onDestroy() {
    if (this.timer) {
      this.$interval.cancel(this.timer);
    }
  }

  isReadingDevice(device) {
    return device.operating_mode === 'reading';
  }

  isReadingDeviceCode(serviceCode) {
    return /^(dss|tds)[0-9]+/.test(serviceCode);
  }

  // demand_alert 以外のエラーが発生している
  isError(deviceError) {
    return deviceError.has_error && (
      deviceError.cloud_disconnected ||
      deviceError.meter_off ||
      deviceError.meter_fault ||
      deviceError.meter_not_found ||
      deviceError.demand_fault
    );
  }

  allDeviceLength() {
    return this.errorList.length + this.correctList.length + this.demandAlertList.length;
  }

  // demand_level が１以上かつ、他のエラーが発生していない
  isDemandAlert(deviceError) {
    return deviceError.demand_level > 0 && !this.isError(deviceError);
  }
}

export default angular.module('leptonApp.home', [uiRouter, moment, DeviceStatusService, EventService, CsvUtil])
  .config(routing)
  .component('home', {
    template: require('./home.html'),
    controller: HomeController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/home/home.component.js